class LpGiftStickyCta extends HTMLElement {
  connectedCallback() {
    this.hero = document.querySelector(this.dataset.heroSelector);
    this.target = document.querySelector(this.dataset.targetSelector);
    this.footer = document.querySelector(this.dataset.footerSelector);
    this.heroPassed = !this.hero;
    this.targetInView = false;
    this.footerInView = false;
    this.observers = [];

    if (this.hero) this.observe(this.hero, (entry) => {
      this.heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
    });
    if (this.target) this.observe(this.target, (entry) => {
      this.targetInView = entry.isIntersecting;
    });
    if (this.footer) this.observe(this.footer, (entry) => {
      this.footerInView = entry.isIntersecting;
    });

    this.updateState();
  }

  disconnectedCallback() {
    this.observers.forEach((observer) => observer.disconnect());
    this.observers = [];
  }

  observe(element, onChange) {
    const observer = new IntersectionObserver(([entry]) => {
      onChange(entry);
      this.updateState();
    });
    observer.observe(element);
    this.observers.push(observer);
  }

  updateState() {
    const visible = this.heroPassed && !this.targetInView && !this.footerInView;
    this.dataset.state = visible ? 'visible' : 'hidden';
  }
}

if (!customElements.get('lp-gift-sticky-cta')) {
  customElements.define('lp-gift-sticky-cta', LpGiftStickyCta);
}
